import { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import store from "@/store";
import { tap } from "rxjs/operators";

// commitee
const CommiteeTemplate = () =>
  import("@/templates/commitee/commitee.template.vue");
const CommiteeIndex = () =>
  import("@/components/commitee/index/commitee-index.vue");
const ListProposalFirst = () =>
  import("@/components/commitee/list-proposal/list-proposal-first.vue");
const ListProposalSecond = () =>
  import("@/components/commitee/list-proposal/list-proposal-second.vue");
const ListProposalThird = () =>
  import("@/components/commitee/list-proposal/list-proposal-third.vue");
const AssignJudgesFirst = () =>
  import("@/components/commitee/assign-judges/assign-judges-first.vue");
const AssignJudgesSecond = () =>
  import("@/components/commitee/assign-judges/assign-judges-second.vue");
const AssignJudgesThird = () =>
  import("@/components/commitee/assign-judges/assign-judges-third.vue");
const VoteResult = () =>
  import("@/components/commitee/vote-result/vote-result.vue");
const DataManagementUser = () =>
  import("@/components/commitee/data-management/data-management-user.vue");
const DataManagementGroup = () =>
  import("@/components/commitee/data-management/data-management-group.vue");
const GenerateReport = () =>
  import("@/components/commitee/generate-report/generate-report.vue");
const CommiteeFeedback = () =>
  import("@/components/commitee/feedback/commitee-feedback.vue");
const CommiteeFeedbackDetail = () =>
  import("@/components/commitee/feedback/commitee-feedback-detail.vue");
const ProposalFirst = () =>
  import("@/components/commitee/proposal/proposal-first.vue");
const ProposalScore = () =>
  import("@/components/commitee/proposal/proposal-score.vue");
const ProposalSecond = () =>
  import("@/components/commitee/proposal/proposal-second.vue");
const VoterList = () =>
  import("@/components/commitee/voter-list/voter-list.vue");
const DetailActivity = () =>
  import("@/components/commitee/data-management/detail-activity.vue");
const CommiteeActivity = () =>
  import("@/components/commitee/data-management/activity.vue");
const Dashboard = () => import("@/components/commitee/dashboard/index.vue");

const MonthlyEvaluation = () =>
  import("@/components/participant/monthly-evaluation/index.vue");

const JuryIndex = () => import("@/components/jury/index/jury-index.vue");
const JuryProposal = () =>
  import("@/components/jury/proposal/jury-proposal.vue");
const JuryScoring = () => import("@/components/jury/scoring/scoring.vue");

const commiteeMiddleware = async (
  _to: Route,
  _from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // Guarantee next() once — navigation must never hang on a dispatch reject /
  // observable error / non-emission (caused random menu freezes until refresh).
  let settled = false;
  const gate = () => {
    if (settled) return;
    settled = true;
    if (store.getters["AuthStore/isCommitee"]) {
      next();
    } else {
      next("/");
    }
  };
  Promise.resolve(store.dispatch("AuthStore/getUser"))
    .then((res) => {
      res.pipe(tap(gate)).subscribe({ error: gate, complete: gate });
    })
    .catch(gate);
  setTimeout(gate, 4000);
};

export default {
  path: "/commitee",
  component: CommiteeTemplate,
  beforeEnter: commiteeMiddleware,
  children: [
    {
      path: "/",
      name: "Home Commitee",
      component: CommiteeIndex,
    },
    {
      path: "dashboard",
      name: "Committee Dashboard",
      component: Dashboard,
    },
    {
      path: "list-proposal/1/old",
      name: "Proposals Phase 1",
      component: ListProposalFirst,
    },
    {
      path: "list-proposal/1",
      name: "Proposals Phase 1",
      component: () =>
        import("@/components/commitee/list-proposal/list-proposal.vue"),
    },
    {
      path: "list-proposal/2",
      name: "Proposals Phase 2",
      component: ListProposalSecond,
    },
    {
      path: "list-proposal/3",
      name: "Proposals Phase 3",
      component: ListProposalThird,
    },
    {
      path: "list-proposal/1/proposal/:id",
      component: ProposalFirst,
    },
    {
      path: "list-proposal/proposal/:id/score",
      component: ProposalScore,
    },
    {
      path: "list-proposal/2/proposal/:id",
      component: ProposalSecond,
    },
    {
      path: "voter-list/:id?",
      component: VoterList,
    },
    {
      path: "assign-judges/1/old",
      name: "Assign Judges Phase 1",
      component: AssignJudgesFirst,
    },
    {
      path: "assign-judges/1",
      name: "Assign Judges Phase 1",
      component: () =>
        import("@/components/commitee/assign-judges/assign-judges.vue"),
    },
    {
      path: "assign-judges/2",
      name: "Assign Judges Phase 2",
      component: AssignJudgesSecond,
    },
    {
      path: "assign-judges/3",
      name: "Assign Judges Phase 3",
      component: AssignJudgesThird,
    },
    {
      path: "vote-result",
      component: VoteResult,
    },
    {
      path: "data-management/user",
      name: "List User",
      component: DataManagementUser,
    },
    {
      path: "data-management/group",
      name: "List Group",
      component: DataManagementGroup,
    },
    {
      path: "data-management/group/:id",
      name: "Edit Group",
      component: () =>
        import("@/components/commitee/data-management/group-form.vue"),
    },
    {
      path: "data-management/faq",
      name: "FAQ Management",
      component: () =>
        import(
          "@/components/commitee/data-management/data-management-faq.vue"
        ),
    },
    {
      path: "data-management/subtema-owner",
      name: "Process Owner Master",
      component: () =>
        import(
          "@/components/commitee/data-management/data-management-subtema-owner.vue"
        ),
    },
    {
      path: "generate-report",
      name: "Generate Report",
      component: GenerateReport,
    },
    {
      path: "feedback",
      name: "List Feedback commitee",
      component: CommiteeFeedback,
    },
    {
      path: "feedback/:id",
      component: CommiteeFeedbackDetail,
    },
    {
      path: "data-management/activity",
      name: "List MonthlyActivity",
      component: CommiteeActivity,
    },
    {
      path: "data-management/activity/:id",
      component: DetailActivity,
    },
    {
      path: "finalreport",
      component: () => import("@/components/commitee/final-report/index.vue"),
    },
    {
      path: "finalreport/:id",
      component: () =>
        import("@/components/participant/final-report/final-report.vue"),
      props: { isAdmin: true },
    },
    {
      path: "finalreport/monthly-evaluation/:id",
      name: "Committee Monthly Evaluation",
      component: MonthlyEvaluation,
    },
    {
      path: "master/topic",
      component: () => import("@/views/MasterTopics.vue"),
    },
    {
      path: "term-and-condition",
      component: () =>
        import("@/components/commitee/commitment-agreement/index.vue"),
    },
    {
      path: "term-and-condition/:id",
      component: () =>
        import("@/components/participant/commitment-agreement/view-detail.vue"),
    },
    {
      path: "quarterly-evaluation",
      component: () => import("@/components/commitee/final-report/index.vue"),
    },
    {
      path: "quarterly-evaluation/:id/:q",
      component: () =>
        import("@/components/commitee/quarterly-evaluation/index.vue"),
    },
    {
      path: "open-clinic",
      component: () =>
        import("@/components/commitee/open-clinic/open-clinic.vue"),
    },
    {
      path: "list-proposal/ebudgeting",
      component: () =>
        import("@/components/commitee/list-proposal/ebudget-monitor.vue"),
    },
    {
      path: "scoring",
      component: JuryIndex,
    },
    {
      path: "scoring/proposal/:id/:juryDetailId",
      component: JuryProposal,
    },
    {
      path: "scoring/score/:phase/:user",
      name: "CommiteeScore",
      component: JuryScoring,
    },
  ],
} as RouteConfig;
